//@import dependencies
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {store} from 'app_storage/redux-storage'
//@end

//@import components
import {LoginScreenLayout} from 'app_components/screens/login'
//@end

//@import services
import AuthService from 'app_services/secure/auth/authService'
import ReactSelectService from 'app_services/components/reactSelectService'
//@end

// @import types
import { IUserHttpResponse } from 'app_types/userTypes'
// @end

function mapStatesToProps(state: any = {}) {
  return state
}

// @ADD Component types
interface ILoginScreenProps {
  history: any
}
interface ILoginScreenState {
  error: string | null
}

class LoginScreen extends Component<ILoginScreenProps, ILoginScreenState> {

  private reactSelectService: ReactSelectService
  storeObject: any

  constructor(props: any) {
    super(props)
    this.storeObject = store
    this.state = {
      error: null,
    }

    this.reactSelectService = new ReactSelectService()
  }

  handleLogin = async (credentials: any) => {
    if (credentials.company) credentials.company = this.reactSelectService.formatReactSelectResponse(credentials.company)

    const authService = new AuthService()
    const loginResult: any = await authService.login(credentials, this.props.history)

    if (loginResult?.status === 'error') {
      this.setState({ error: loginResult?.message })
    }
  }

  handlePasswordRecover = async (userData: IUserHttpResponse) => {
    const authService = new AuthService()
    const loginResult: any = await authService.processLogin(userData, this.props.history)
  }

  render() {
    return(
      <LoginScreenLayout
        onHandleLogin={this.handleLogin}
        error={this.state.error}
        onHandlePasswordRecover={this.handlePasswordRecover}
        history={this.props.history}
      />
    )
  }
}

export default connect(mapStatesToProps)(LoginScreen)
